module.exports = [
  {
    "Geography": "United States",
    "Year": "1999",
    "Rate": 875.6
  },
  {
    "Geography": "United States",
    "Year": "2000",
    "Rate": 869
  },
  {
    "Geography": "United States",
    "Year": "2001",
    "Rate": 858.8
  },
  {
    "Geography": "United States",
    "Year": "2002",
    "Rate": 855.9
  },
  {
    "Geography": "United States",
    "Year": "2003",
    "Rate": 843.5
  },
  {
    "Geography": "United States",
    "Year": "2004",
    "Rate": 813.7
  },
  {
    "Geography": "United States",
    "Year": "2005",
    "Rate": 815
  },
  {
    "Geography": "United States",
    "Year": "2006",
    "Rate": 791.8
  },
  {
    "Geography": "United States",
    "Year": "2007",
    "Rate": 775.3
  },
  {
    "Geography": "United States",
    "Year": "2008",
    "Rate": 774.9
  },
  {
    "Geography": "United States",
    "Year": "2009",
    "Rate": 749.6
  },
  {
    "Geography": "United States",
    "Year": "2010",
    "Rate": 747
  },
  {
    "Geography": "United States",
    "Year": "2011",
    "Rate": 741.3
  },
  {
    "Geography": "United States",
    "Year": "2012",
    "Rate": 732.8
  },
  {
    "Geography": "United States",
    "Year": "2013",
    "Rate": 731.9
  },
  {
    "Geography": "United States",
    "Year": "2014",
    "Rate": 724.6
  },
  {
    "Geography": "United States",
    "Year": "2015",
    "Rate": 733.1
  },
  {
    "Geography": "United States",
    "Year": "2016",
    "Rate": 728.8
  },
  {
    "Geography": "United States",
    "Year": "2017",
    "Rate": 731.9
  },
  {
    "Geography": "United States",
    "Year": "2018",
    "Rate": 723.6
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "1999",
    "Rate": 1028.6
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2000",
    "Rate": 1017.8
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2001",
    "Rate": 1007
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2002",
    "Rate": 1019.4
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2003",
    "Rate": 999
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2004",
    "Rate": 990.4
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2005",
    "Rate": 1014.9
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2006",
    "Rate": 931.2
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2007",
    "Rate": 900.8
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2008",
    "Rate": 894.8
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2009",
    "Rate": 848.2
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2010",
    "Rate": 840.2
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2011",
    "Rate": 831.7
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2012",
    "Rate": 835.9
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2013",
    "Rate": 827.6
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2014",
    "Rate": 818.5
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2015",
    "Rate": 788.7
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2016",
    "Rate": 794.6
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2017",
    "Rate": 814.7
  },
  {
    "Geography": "Metro New Orleans",
    "Year": "2018",
    "Rate": 798.8
  }
]
